'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ../~/react/react.js
// module id = 416
// module chunks = 2